export default __webpack_public_path__ + "static/media/flag.13cf6ab9.png";